/* eslint-disable */
export default {
  noActiveCalls: 'Keine aktiven Anrufe',
  currentCall: 'Aktueller Anruf',
  ringCall: 'Anruf wird getätigt',
  onHoldCall: 'Anruf wird gehalten',
  otherDeviceCall: 'Aktuelle Gespräche auf meinen anderen Geräten',
  confirmation: 'Bestätigung',
  confirmMergeToConference: 'Zur Telefonkonferenz hinzufügen?',
  mergeToConference: 'Zusammenführen',
  conferenceCall: 'Telefonkonferenz',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
